import React from 'react';
import { Box, Button, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Skeleton, useTheme } from '@mui/material';
import { tokens } from '../../theme';

import AddCircleIcon from '@mui/icons-material/AddCircle';



export default function SkeletonVoucherTable() {
    const rows = Array.from({ length: 3 }); // Generate 7 rows for the skeleton
    const theme = useTheme();
    const colors = tokens(theme.palette.mode);


    return (
        <Paper
            sx={{
                backgroundColor: '#72203b', // Matches the table background in your design
                padding: '16px',
                borderRadius: '8px',
                color: '#fff',
                width: '100%'
            }}
        >
            <Box
                sx={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    mb: 2,
                }}
            >
                <Box sx={{ fontSize: '1.2rem', fontWeight: 'bold', color: '#fff' }}>
                    Resumo de Pagamento
                </Box>
            </Box>
            <TableContainer>
                <Table>
                    <TableHead>
                        <TableRow>
                            <TableCell align="center" sx={{ color: '#fff', fontWeight: 'bold' }}>ID</TableCell>
                            <TableCell align="center" sx={{ color: '#fff', fontWeight: 'bold' }}>Valor</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {rows.map((_, index) => (
                            <TableRow key={index}>
                                <TableCell align="center">
                                    <Skeleton variant="text" width={20} height={20} />
                                </TableCell>
                                <TableCell align="center">
                                    <Skeleton variant="text" width={280} height={20} />
                                </TableCell>
                                
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
            </TableContainer>
        </Paper>
    );
}